/* eslint-disable no-unused-vars */
import MailAccountService from "@/services/data/email-account";

import { SET_DATA, SET_PAGINATION } from "./types";

export async function fetchData({commit}, params) {
  const {data} = await MailAccountService.get(params);
  const {accounts, pagination} = data.data;
  commit(SET_DATA, accounts);
  commit(SET_PAGINATION, pagination);
  return accounts;
}

export async function importData({commit}, params) {
  const {data} = await MailAccountService.import(params);
  return data;
}

export async function deleteData({commit}, params) {
  const {data} = await MailAccountService.delete(params);
  return data;
}

export async function unassignTag({commit}, params) {
  const {data} = await MailAccountService.unassignTag(params);
  return data;
}

export async function unassignTagByFilter({commit}, params) {
  const {data} = await MailAccountService.unassignTagByFilter(params);
  return data;
}

export async function fetchById({commit}, id) {
  const {data} = await MailAccountService.getById(id);
  return data.data;
}

export async function checkLiveEmailFilter({commit}, params) {
  const {data} = await MailAccountService.checkLiveEmailFilter(params);
  return data;
}